import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
// import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
// import MailOutlineIcon from "@mui/icons-material/MailOutline";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import Zoom from "react-medium-image-zoom";
import SearchIcon from "@mui/icons-material/Search";

// For Date Picker
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
// End

import PercentSharpIcon from "@mui/icons-material/PercentSharp";

// import { useEffect } from "react";
import swal from "sweetalert";
import { makeGetRequest, makePostRequest } from "../../../utils/utils";
import dayjs from "dayjs";
import { Formik, Form } from "formik";
import * as Yup from "yup";
// import moment from "moment";

function SendInvoiceTo() {
  const navigate = useNavigate();

  // For Tab
  // const [value, setValue] = React.useState(0);

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };
  // End

  // const [, setOwnersList] = React.useState([]);
  const [apartmentList, setApartmentList] = React.useState([]);
  // const [q, setQ] = React.useState("");
  const [selectedOwner, setSelectedOwner] = React.useState("");
  const [selectedApartment, setSelectedApartment] = React.useState("");

  // const [ownerData, setOwnerData] = React.useState({});

  const [invoiceNo, setInvoiceNo] = React.useState(0);
  const [invoice_date, setInvoiceDate] = React.useState(dayjs(new Date()));
  const [due_date, setDueDate] = React.useState(invoice_date.add(15, "day"));
  const [subject] = React.useState();
  const [invoiceType, setInvoiceType] = React.useState("Monthly Maintenance");

  const [, setBillTo] = React.useState("");
  const [, setWing] = React.useState("");
  const [, setApartmentNo] = React.useState("");
  const [, setContactNo] = React.useState("");
  const [, setEmailId] = React.useState("");

  const [note, setNote] = React.useState("");
  // const [cgst, setCgst] = React.useState(10);
  // const [sgst, setSgst] = React.useState(10);
  // const [cgstAmt, setCgstAmt] = React.useState(0);
  // const [sgstAmt, setSgstAmt] = React.useState(0);
  const [subTotal, setSubTotal] = React.useState(0);
  const [advanceReceived, setAdvanceReceived] = React.useState(100);
  const [past_due, setPastDue] = React.useState(0);
  const [lateFee, setLateFee] = React.useState(0);
  const [totalPayable, setTotalPayable] = React.useState(0);
  // const [maintenenceIdList, setMaintenenceIdList] = React.useState([]);
  const [maintenenceList] = React.useState([]);
  const [maintenenceJsonList, setMaintenenceJsonList] = React.useState([]);
  const [misch_JsonList, setMischJsonList] = React.useState([]);
  const [otherJsonList] = React.useState([]);

  const [taxList, setTaxList] = React.useState([]);

  const [amenitiesList, setAmenitiesList] = React.useState([]);
  const [amenitiesJsonList] = React.useState([]);

  const [selectedAmenity, setSelectedAmenity] = React.useState("");
  const [selectedAmenityName, setSelectedAmenityName] = React.useState("");

  const [amount, setAmount] = React.useState(0);
  const [, setNoOfDays] = React.useState(0);
  // const [total, setTotal] = React.useState(0);

  // const [arr_amount, setArr_amount] = React.useState("");
  // const [arr_noOfDays, setArr_noOfDays] = React.useState();
  // const [arr_tot_Charges, setArr_tot_Charges] = React.useState();

  // const [inputMaintenence,setInputMaintenence]=React.useState("");
  // const [inputAmount,setInputAmount]=React.useState();

  let mainteneceJson;
  const [maintenenceTotal, setMaintenenceTotal] = React.useState(0);
  const [, setTaxTotal] = React.useState(0);

  let taxJson;
  const [taxJsonList, SetTaxJsonList] = React.useState([]);

  const getAddedMaintenence = (e) => {
    alert("On Blur called");
  };

  const Validation_Schema = Yup.object().shape({
    subject: Yup.string()
      .required("Required")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Numbers not allowed!!"
      ),
    note: Yup.string()
      .required("Required")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Numbers not allowed!!"
      ),
  });

  var formikInitials = {
    subject: subject,
    note: note,
  };

  // async function OwnerListing(q) {
  //   let bodyFormData = {
  //     searchq: q,
  //   };
  //   makePostRequest("resident/getall", bodyFormData)
  //     .then((response) => {
  //       if (response.status == "201") {
  //         console.log("Owner Data");
  //         console.log(response.data.data);
  //         // setlength(response.data.data.rowCount);
  //         const data = response.data.data;
  //         setOwnersList(data);
  //       } else {
  //         swal("There was an error!", response.message, "warning");
  //       }
  //     })
  //     .catch((err) => {
  //       swal("There was an error!", "more error details", "warning");
  //     });
  // }

  // async function MaintenenceListing() {
  //   let bodyFormData = {};

  //   makeGetRequest("maintenence/getallbystatus/true", bodyFormData)
  //     .then((response) => {
  //       if (response.status == "201") {
  //         console.log("Maintenence Data");
  //         console.log(response.data.data);
  //         // setlength(response.data.data.rowCount);
  //         const data = response.data.data;
  //         setMaintenenceList(data);
  //       } else {
  //         swal("There was an error!", response.message, "warning");
  //       }
  //     })
  //     .catch((err) => {
  //       swal("There was an error!", "more error details", "warning");
  //     });
  // }

  const handlechangeOwner = (residentId) => {
    setSelectedOwner(residentId);
    // console.log("Building Data ", e);

    makeGetRequest("resident/getalldetails/" + residentId, "")
      .then((response) => {
        if (response.status === 201) {
          console.log("Owner Obj");
          console.log(response.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          // setOwnerData(data);
          setApartmentList(response.data.apartmentList);
          setBillTo(data.user_obj.first_name + " " + data.user_obj.last_name);
          setEmailId(data.user_obj.email_id);
          setContactNo(data.user_obj.contact_no);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
    // setOwnerData()
  };

  async function handleChangeTabs(invoiceType) {
    setInvoiceType(invoiceType);

    if (invoiceType == "Monthly Maintenance") {
      window.location.reload();
    } else {
      setSelectedOwner("");
      setSelectedApartment("");
      setBillTo("");
      setWing("");
      setApartmentNo("");
      setContactNo("");
      setEmailId("");
      setMaintenenceTotal(0);
      setSubTotal(0);
      setTotalPayable(0);
      setAdvanceReceived(0);
    }
  }

  async function handleAdvanceReceived(advanceReceived) {
    setAdvanceReceived(advanceReceived);
    setTotalPayable(subTotal - advanceReceived);
  }

  async function handlechangeApartment(selectedApartmentId, invoiceType) {
    alert("In Handle Change");
    var selectedApartment = selectedApartmentId;
    setSelectedApartment(selectedApartmentId);

    if (invoiceType == "Monthly Maintenance") {
      var total = maintenenceTotal;
      for (var i = 0; i < apartmentList.length; i++) {
        if (apartmentList[i].apartment_id == selectedApartment) {
          var apartmentObj = apartmentList[i];
          console.log("selected Apartment ", apartmentObj);
          setApartmentNo(apartmentObj.uniq_apt_name);

          for (var j = 0; j < maintenenceList.length; j++) {
            // maintenenceIdList[j] = maintenenceList[j].maintenence_id;
            console.log("Before total ", total);
            total = total + maintenenceList[j].amount;
            console.log("After total ", total);
          }
          var tax = 0;
          var previousMonthTotPayable = 0;
          for (var k = 0; k < taxList.length; k++) {
            taxJson = { key: "", value: "", total: "" };

            var calculatedTax;
            if (taxList[k].tax_name === "Late Fee") {
              let latefeeAmt = taxList[k].tax_amount;
              let previousInvoice = "";

              await makeGetRequest(
                "invoice/getpreviousmonth/" +
                  selectedOwner +
                  "/" +
                  selectedApartment,
                ""
              )
                .then((response) => {
                  if (response.status == "201") {
                    previousInvoice = response.data.data;
                  }
                })
                .catch((err) => {
                  swal("There was an error!", "more error details", "warning");
                });

              if (previousInvoice) {
                if (previousInvoice.is_paid) {
                  alert("Invoice is paid");
                  alert(new Date(previousInvoice.due_date).getTime());

                  if (
                    new Date(previousInvoice.paid_date).getTime() >
                    new Date(previousInvoice.due_date).getTime()
                  ) {
                    //Apply late fee
                    alert("Late Fee applicable");
                    alert(latefeeAmt);
                    // +' taxList[k] '+taxList[k].tax_amount);
                    var calculated_lateFee = (total * latefeeAmt) / 100;
                    taxList[k].calculatedTax = calculated_lateFee;
                    tax = tax + calculated_lateFee;
                    setLateFee(calculated_lateFee);
                    alert(calculated_lateFee);
                  }
                } else {
                  let calculated_lateFee =
                    (total * taxList[k].tax_amount) / 100;
                  taxList[k].calculatedTax = calculated_lateFee;
                  tax = tax + calculated_lateFee;

                  previousMonthTotPayable = previousInvoice.total_payment;
                  setPastDue(previousMonthTotPayable);
                  setLateFee(calculated_lateFee);
                }
              } else taxList[k].calculatedTax = 0;
            } else {
              calculatedTax = (total * taxList[k].tax_amount) / 100;
              taxList[k].calculatedTax = calculatedTax;
              tax = tax + calculatedTax;
            }
            console.log("calculatedTaxList ", taxList);
            taxJson.key = taxList[k].tax_name;
            taxJson.value = taxList[k].tax_amount;
            taxJson.total = taxList[k].calculatedTax;
            taxJsonList.push(taxJson);
            SetTaxJsonList(taxJsonList);
          }

          // setMaintenenceIdList(maintenenceIdList);
          // console.log("maintenenceList ", maintenenceIdList);

          setMaintenenceTotal(total);
          setTaxTotal(tax);
          setSubTotal(total + tax);

          setTotalPayable(total - advanceReceived + tax);
          console.log("Subtotal ", subTotal);
        }
      }
    } else if (invoiceType == "Miscellaneous") {
      AmenityListing();
    }
  }

  async function handlechangeAmenity(e) {
    setSelectedAmenity(e.target.value);
    let idx = e.target.selectedIndex;
    let dataset = e.target.options[idx].dataset;
    console.log(e.target.options[idx]);

    setSelectedAmenityName(dataset.name);

    setAmount(dataset.isd);
    document.getElementById("amenityAmt").value = dataset.isd;
  }

  let amenityJson;

  async function handleInputDays(e) {
    console.log(e);

    // setTotal(amount * e.target.value);
    document.getElementById("AmenityTotalAmt").value = amount * e.target.value;

    let total = maintenenceTotal + amount * e.target.value;

    console.log("Total " + total);
    setMaintenenceTotal(total);

    let miscellaneousTaxTotal = 0;

    console.log(taxJsonList);

    while (taxJsonList.length > 0) {
      taxJsonList.pop();
    }
    console.log(taxJsonList);

    taxList.map((option, index) => {
      taxJson = { key: "", value: "", total: "" };

      if (option.tax_name == "Late Fee") {
        // taxJson.key = option.tax_name;
        // taxJson.value = option.tax_amount;
        // taxJson.total = 0;
      } else {
        // option.calculatedTax = (misc_total * option.tax_amount) / 100;
        miscellaneousTaxTotal =
          miscellaneousTaxTotal + (total * option.tax_amount) / 100;
        // taxList[index] = option;
        //  setMiscellaneousTaxTotal(miscellaneousTaxTotal);

        taxJson.key = option.tax_name;
        taxJson.value = option.tax_amount;
        taxJson.total = (total * option.tax_amount) / 100;
        taxJsonList.push(taxJson);
      }
    });

    SetTaxJsonList(taxJsonList);

    setTaxTotal(miscellaneousTaxTotal);
    setSubTotal(total + miscellaneousTaxTotal);
    setTotalPayable(total + miscellaneousTaxTotal - advanceReceived);
  }

  // For Date Picker
  const [value1, setValue1] = React.useState(new dayjs());

  const handleInvoiceDate = (newValue) => {
    setInvoiceDate(newValue);
    setDueDate(invoice_date.add(1, "month"));
  };

  // const [value2, setValue2] = React.useState(dayjs('2014-08-18T21:11:54'));
  const handleDueDate = (newValue) => {
    setDueDate(newValue);
  };
  // End

  async function TaxListing() {
    let bodyFormData = {};

    await makeGetRequest("tax/getallbystatus/true", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          console.log("Tax details Data");
          console.log(response.data.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          setTaxList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const deleteField = () => {
    alert("No click delete this Field");
  };

  async function sendInvoiceEmail(invoiceObj) {
    let invoiceHtml2 =
      '<!doctype html><html> <head><meta charset="utf-8"><title>Email</title> <link href="css/bootstrap.min.css" rel="stylesheet"> <link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><meta name="viewport" content="width=device-width, initial-scale=1"></head><body> <div style="width: 100%; max-width: 650px; margin: 50px auto; border: 1px solid #ccc;border-radius: 10px;overflow: hidden;font-family:\'Poppins\', sans-serif;"><div style="background: #674BDD; text-align: center;color: #fff;font-family: \'Poppins\', sans-serif; font-weight: 700;font-size: 28px; letter-spacing: 1px;padding: 20px;box-sizing: border-box;float: left;width: 100%;">Paradise Housing Society <p style="color: #fff; font-size: 16px;font-weight: 400;font-family: \'Poppins\', sans-serif;"> Cecilia Chapman 711-2880 Nulla St. Mankato Mississippi 96522 </p></div><div style="width: 100%;float: left;padding: 30px 30px 0px;box-sizing: border-box;"><h1 style="width: 100%;float: left;color: #1F1F1F;font-size: 21px;font-weight: 700;text-align: center;margin-bottom: 40px;">Your monthly maintenance invoice is ready</h1><p style="width: 100%; float: left; margin-bottom: 8px; margin-top: 0; font-weight: 500; color: #1F1F1F; font-size: 16px;">Hello, Prakash J.</p><p style="width: 100%; float: left; font-weight: 500; margin-top: 0; color: #1F1F1F; font-size: 16px;"> your most recent monthly maintenance bill is available here. </p></div><h2 style="width: 100%;float: left;font-size: 19px;font-weight: 600;color: #1F1F1F;padding: 0px 30px; box-sizing: border-box;">Invoice Details :</h2><div style="width: 100%;float: left;background: #F3F6FE;padding: 30px 30px;box-sizing: border-box;"> <p style="color:#1F1F1F; font-size:15px; font-weight: 500;margin-top: 0;"><b style="color: #313131;font-size:15px; font-weight: 500;max-width: 150px;width: 100%;float: left;">Bill No</b> <span>: 239867</span></p><p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #313131;font-size:15px; font-weight: 500;max-width: 150px;width: 100%;float: left;">Period</b> <span>: 01-09-22 to 30-09-22</span></p><p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #313131;font-size:15px; font-weight: 500;max-width: 150px;width: 100%;float: left;">Bill Date</b> <span>: 01-10-22</span></p> <p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #313131;font-size:15px; font-weight: 500;max-width: 150px;width: 100%;float: left;">Due Date</b> <span>: 15-10-22</span></p><p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #313131;font-size:15px; font-weight: 500;max-width: 150px;width: 100%;float: left;">Flat No</b> <span>: Wing-B / 204</span></p><p style="color:#1F1F1F; font-size:15px; font-weight: 500; font-weight: 500; line-height: 40px;margin-bottom: 0;"><b style="color: #674BDD;font-size:15px; font-weight: 600;max-width: 150px;width: 100%;float: left;">Total Payable</b> <span style="color: #674BDD;font-size:21px; font-weight: 600;">: 7000</span></p></div><div style="width: 100%;float: left;padding: 30px 30px;box-sizing: border-box;"><h2 style="width: 100%;float: left;font-size: 19px;font-weight: 600;color: #1F1F1F;margin-bottom: 20px;">Bank Details :</h2> <p style="color:#1F1F1F; font-size:15px; font-weight: 500;margin-top: 0;"><b style="color: #525252;font-size:15px; font-weight: 600;max-width: 210px;width: 100%;float: left;letter-spacing: 1px;">Name of Account</b> <span style="letter-spacing: 1px;">: Paradise Housing Society</span></p><p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #525252;font-size:15px; font-weight: 600;max-width: 210px;width: 100%;float: left;letter-spacing: 1px;">Bank name</b> <span style="letter-spacing: 1px;">: Union Bank of India</span></p> <p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #525252;font-size:15px; font-weight: 600;max-width: 210px;width: 100%;float: left;letter-spacing: 1px;">Branch Code</b> <span style="letter-spacing: 1px;">: 1214 Azad Nagar </span></p> <p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #525252;font-size:15px; font-weight: 600;max-width: 210px;width: 100%;float: left;letter-spacing: 1px;">Account  Number</b> <span style="letter-spacing: 1px;">: 56748905467</span></p> <p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #525252;font-size:15px; font-weight: 600;max-width: 210px;width: 100%;float: left;letter-spacing: 1px;">IFSC Code</b> <span style="letter-spacing: 1px;">: UBIN0912140</span></p> </div><div style="width: 100%;float: left;text-align: center;margin-bottom: 30px;"> <a style="font-size: 16px;font-weight: 500;color: #fff;border: none;background: #08AE36;width: 100%;display: inline-block;margin: 0 5px;max-width: 230px;padding: 18px 15px;border-radius: 10px;cursor: pointer;">Pay Now</a> <a style="font-size: 16px;font-weight: 500;color: #fff;border: none;background: #674BDD;width: 100%;display: inline-block;margin: 0 5px;max-width: 230px;padding: 18px 15px;border-radius: 10px;cursor: pointer;">Preview</a></div><div style="width: 100%;float: left; box-sizing: border-box;"> <img style="width: 100%; float: left;" src="https://suprawebservices.com/works/society_managment_img/buildings.png"/></div></div></body>  </html>';

    let bodyFormData = { invoiceHtml: invoiceHtml2 };
    await makePostRequest("invoice/sendemail", bodyFormData)
      .then((response) => {
        if (response.data.data !== undefined) {
          alert("Mail Sent");
          // console.log("Max Id ", response.data.data.rows[0].maxid);
          // setInvoiceNo(response.data.data.rows[0].maxid + 1);
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function saveInvoice() {
    alert("In Save Invoice");
    // const [appliedTaxJson,setAppliedTaxJson]=React.useState({key:'',value:''});

    console.log("invoice_date ", invoice_date);
    console.log("due_date ", due_date);
    console.log("selectedOwner ", selectedOwner);

    if (invoice_date && due_date && selectedOwner) {
      let inputdata;
      alert(invoiceType);
      if (invoiceType == "Monthly Maintenance") {
        handleMonthlySave();

        if (otherJsonList.length > 0) {
          otherJsonList.map((option, index) => {
            mainteneceJson = { key: "", value: "" };
            mainteneceJson.key = option.key;
            mainteneceJson.value = option.value;
            maintenenceJsonList.push(mainteneceJson);
          });
        }

        taxJsonList.map((option, index) => {
          mainteneceJson = { key: "", value: "", total: "" };
          mainteneceJson.key = option.key;
          mainteneceJson.value = option.value;
          mainteneceJson.total = option.total;
          maintenenceJsonList.push(mainteneceJson);
        });

        inputdata = {
          invoice_date: invoice_date,
          due_date: due_date,
          invoice_type: invoiceType,
          resident_id: selectedOwner,
          apartment_id: selectedApartment,
          subject: subject,
          maintenence_json_list: maintenenceJsonList,
          total_payment: subTotal,
          advance_received: advanceReceived,
          is_paid: false,
          past_due: past_due,
          late_fee: lateFee,
        };
      } else if (invoiceType == "Miscellaneous") {
        handleChangeSave();

        if (
          selectedAmenity &&
          document.getElementById("amenity_duration").value &&
          document.getElementById("AmenityTotalAmt").value
        ) {
          miscellaneousJson = { name: "", amount: "", duration: "", total: "" };
          miscellaneousJson.name = selectedAmenityName;
          miscellaneousJson.amount = amount;
          miscellaneousJson.duration =
            document.getElementById("amenity_duration").value;
          miscellaneousJson.total =
            document.getElementById("AmenityTotalAmt").value;

          misch_JsonList.push(miscellaneousJson);

          amenitiesJsonList.push(miscellaneousJson);
        }

        for (var i = 0; i < taxJsonList.length; i++) {
          miscellaneousJson = { name: "", amount: "", duration: "", total: "" };

          miscellaneousJson.name = taxJsonList[i].key;
          miscellaneousJson.amount = taxJsonList[i].value;
          miscellaneousJson.duration = 0;
          miscellaneousJson.total = taxJsonList[i].total;
          misch_JsonList.push(miscellaneousJson);
        }
        inputdata = {
          invoice_date: invoice_date,
          due_date: due_date,
          invoice_type: invoiceType,
          resident_id: selectedOwner,
          apartment_id: selectedApartment,
          subject: subject,
          maintenence_json_list: misch_JsonList,
          total_payment: subTotal,
          advance_received: advanceReceived,
          is_paid: false,
          past_due: past_due,
          late_fee: lateFee,
        };
      }

      makePostRequest("invoice/insert", inputdata)
        .then((response) => {
          if (response.data.data !== undefined) {
            swal("Success", "Invoice Created Successully....", "success", {
              timer: 1000,
              buttons: false,
            });
            console.log(response.data.data);
            // sendInvoiceEmail(response.data.data);

            let invoiceHtml2 =
              '<!doctype html><html> <head><meta charset="utf-8"><title>Email</title> <link href="css/bootstrap.min.css" rel="stylesheet"> <link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><meta name="viewport" content="width=device-width, initial-scale=1"></head><body> <div style="width: 100%; max-width: 650px; margin: 50px auto; border: 1px solid #ccc;border-radius: 10px;overflow: hidden;font-family:\'Poppins\', sans-serif;"><div style="background: #674BDD; text-align: center;color: #fff;font-family: \'Poppins\', sans-serif; font-weight: 700;font-size: 28px; letter-spacing: 1px;padding: 20px;box-sizing: border-box;float: left;width: 100%;">Paradise Housing Society <p style="color: #fff; font-size: 16px;font-weight: 400;font-family: \'Poppins\', sans-serif;"> Cecilia Chapman 711-2880 Nulla St. Mankato Mississippi 96522 </p></div><div style="width: 100%;float: left;padding: 30px 30px 0px;box-sizing: border-box;"><h1 style="width: 100%;float: left;color: #1F1F1F;font-size: 21px;font-weight: 700;text-align: center;margin-bottom: 40px;">Your monthly maintenance invoice is ready</h1><p style="width: 100%; float: left; margin-bottom: 8px; margin-top: 0; font-weight: 500; color: #1F1F1F; font-size: 16px;">Hello, Prakash J.</p><p style="width: 100%; float: left; font-weight: 500; margin-top: 0; color: #1F1F1F; font-size: 16px;"> your most recent monthly maintenance bill is available here. </p></div><h2 style="width: 100%;float: left;font-size: 19px;font-weight: 600;color: #1F1F1F;padding: 0px 30px; box-sizing: border-box;">Invoice Details :</h2><div style="width: 100%;float: left;background: #F3F6FE;padding: 30px 30px;box-sizing: border-box;"> <p style="color:#1F1F1F; font-size:15px; font-weight: 500;margin-top: 0;"><b style="color: #313131;font-size:15px; font-weight: 500;max-width: 150px;width: 100%;float: left;">Bill No</b> <span>: 239867</span></p><p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #313131;font-size:15px; font-weight: 500;max-width: 150px;width: 100%;float: left;">Period</b> <span>: 01-09-22 to 30-09-22</span></p><p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #313131;font-size:15px; font-weight: 500;max-width: 150px;width: 100%;float: left;">Bill Date</b> <span>: 01-10-22</span></p> <p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #313131;font-size:15px; font-weight: 500;max-width: 150px;width: 100%;float: left;">Due Date</b> <span>: 15-10-22</span></p><p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #313131;font-size:15px; font-weight: 500;max-width: 150px;width: 100%;float: left;">Flat No</b> <span>: Wing-B / 204</span></p><p style="color:#1F1F1F; font-size:15px; font-weight: 500; font-weight: 500; line-height: 40px;margin-bottom: 0;"><b style="color: #674BDD;font-size:15px; font-weight: 600;max-width: 150px;width: 100%;float: left;">Total Payable</b> <span style="color: #674BDD;font-size:21px; font-weight: 600;">: 7000</span></p></div><div style="width: 100%;float: left;padding: 30px 30px;box-sizing: border-box;"><h2 style="width: 100%;float: left;font-size: 19px;font-weight: 600;color: #1F1F1F;margin-bottom: 20px;">Bank Details :</h2> <p style="color:#1F1F1F; font-size:15px; font-weight: 500;margin-top: 0;"><b style="color: #525252;font-size:15px; font-weight: 600;max-width: 210px;width: 100%;float: left;letter-spacing: 1px;">Name of Account</b> <span style="letter-spacing: 1px;">: Paradise Housing Society</span></p><p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #525252;font-size:15px; font-weight: 600;max-width: 210px;width: 100%;float: left;letter-spacing: 1px;">Bank name</b> <span style="letter-spacing: 1px;">: Union Bank of India</span></p> <p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #525252;font-size:15px; font-weight: 600;max-width: 210px;width: 100%;float: left;letter-spacing: 1px;">Branch Code</b> <span style="letter-spacing: 1px;">: 1214 Azad Nagar </span></p> <p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #525252;font-size:15px; font-weight: 600;max-width: 210px;width: 100%;float: left;letter-spacing: 1px;">Account  Number</b> <span style="letter-spacing: 1px;">: 56748905467</span></p> <p style="color:#1F1F1F; font-size:15px; font-weight: 500;"><b style="color: #525252;font-size:15px; font-weight: 600;max-width: 210px;width: 100%;float: left;letter-spacing: 1px;">IFSC Code</b> <span style="letter-spacing: 1px;">: UBIN0912140</span></p> </div><div style="width: 100%;float: left;text-align: center;margin-bottom: 30px;"> <a style="font-size: 16px;font-weight: 500;color: #fff;border: none;background: #08AE36;width: 100%;display: inline-block;margin: 0 5px;max-width: 230px;padding: 18px 15px;border-radius: 10px;cursor: pointer;">Pay Now</a> <a style="font-size: 16px;font-weight: 500;color: #fff;border: none;background: #674BDD;width: 100%;display: inline-block;margin: 0 5px;max-width: 230px;padding: 18px 15px;border-radius: 10px;cursor: pointer;">Preview</a></div><div style="width: 100%;float: left; box-sizing: border-box;"> <img style="width: 100%; float: left;" src="https://suprawebservices.com/works/society_managment_img/buildings.png"/></div></div></body>  </html>';
            navigate("/InvoiceListing");
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
        });
    } else {
      swal("Please fill all details!", "", "warning");
    }
  }

  async function getMaxInvoiceId() {
    console.log("In Get Max Invoice Id");
    await makeGetRequest("invoice/getmaxid", "")
      .then((response) => {
        if (response.data.data !== undefined) {
          console.log("Max Id ", response.data.data.rows[0].maxid);
          setInvoiceNo(response.data.data.rows[0].maxid + 1);
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function AmenityListing() {
    let bodyFormData = {};

    await makeGetRequest("amenities/getall", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          console.log("Amenity List");
          console.log(response.data.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          setAmenitiesList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  // For Append
  const { useState } = React;

  let index = 0;

  const [count, setCount2] = useState(0);
  // End

  // For Append kkk
  const { useState1 } = React;
  let index1 = 0;

  const AddedElement1 = () => (
    <div className="addedAppendLine" id="deleteId">
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <input className="inputSt" placeholder="Maintenence Name" />
        </Grid>
        <Grid item xs={12} md={4}>
          <div className="inputWithICon">
            <CurrencyRupeeIcon />
            <input
              className="inputSt"
              placeholder="Amount"
              onBlur={(event) => getAddedMaintenence()}
            />
          </div>
        </Grid>

        <Button className="minusBtnNew">
          <RemoveIcon />
        </Button>
      </Grid>
    </div>
  );
  const [count1, setCount1] = useState(0);
  // End

  const addAminitiesClick = () => {
    if (invoiceType == "Miscellaneous") {
      handleChangeSave();
    } else {
      let tempMaintenenceList;
      let total = 0;

      for (var i = 0; i < maintenenceList.length; i++) {
        tempMaintenenceList = { key: "", value: "" };
        tempMaintenenceList.key = maintenenceList[i].maintenence_type;
        tempMaintenenceList.value = maintenenceList[i].amount;
        total = total + maintenenceList[i].amount;

        // appliedTaxJsonList.push(appliedTaxJson);
        maintenenceJsonList.push(tempMaintenenceList);
      }

      //   for (var i = 0; i < taxList.length; i++) {
      //     appliedTaxJson = { key: "", value: "" };
      //     if (taxList[i].tax_name === "Late Fee") {
      //       appliedTaxJson.key = taxList[i].tax_name;
      //       appliedTaxJson.value = lateFee;
      //       // appliedTaxJsonList.push(appliedTaxJson);
      //       maintenenceJsonList.push(appliedTaxJson);
      //     } else {
      //       appliedTaxJson.key = taxList[i].tax_name;
      //       appliedTaxJson.key = taxList[i].tax_name;
      //       appliedTaxJson.value = (total * taxList[i].tax_amount) / 100;
      //       maintenenceJsonList.push(appliedTaxJson);
      //     }

      // }
    }
    var element = document.getElementById("addAminitiesId");
    element.classList.add("aminitiesMainAdd");
  };

  const [isEditMonthlyInvoice, setIsEditMonthlyInvoice] = useState(false);

  async function EditMonthlyInvoice(invoiceId) {
    setIsEditMonthlyInvoice(true);
    await makeGetRequest("invoice/getbyid/" + invoiceId)
      .then((response) => {
        if (response.status == "201") {
          console.log("Invoice details Data");
          console.log(response.data.data);
          var invoiceObj = response.data.data;
          console.log(invoiceObj.maintenence_json_list);

          setInvoiceNo(invoiceObj.invoice_id);
          // setSelectedOwner(invoiceObj.resident_id);
          handlechangeOwner(invoiceObj.resident_id);
          handlechangeApartment(
            invoiceObj.apartment_id,
            invoiceObj.invoice_type
          );

          setInvoiceType(invoiceObj.invoice_type);
          setInvoiceDate(dayjs(invoiceObj.invoice_date).subtract(1, "day"));
          setDueDate(dayjs(invoiceObj.due_date).subtract(1, "day"));
          setMaintenenceJsonList(invoiceObj.maintenence_json_list);
          setSubTotal(invoiceObj.total_payment);
          setAdvanceReceived(invoiceObj.advance_received);
          setTotalPayable(
            invoiceObj.total_payment - invoiceObj.advance_received
          );
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  let temp_subtotal = 0;

  async function handleMonthlySave() {
    if (
      document.getElementById("inputMaintenence").value &&
      document.getElementById("inputAmount").value
    ) {
      setCount1(index);
      alert("In HandleChange");

      mainteneceJson = { key: "", value: "" };
      mainteneceJson.key = document.getElementById("inputMaintenence").value;
      mainteneceJson.value = document.getElementById("inputAmount").value;
      maintenenceJsonList.push(mainteneceJson);

      var total =
        maintenenceTotal +
        parseInt(document.getElementById("inputAmount").value);

      setMaintenenceTotal(total);

      let monthlyTaxTotal = 0;

      while (taxJsonList.length > 0) {
        taxJsonList.pop();
      }
      taxList.map((option, index) => {
        taxJson = { key: "", value: "", total: "" };

        if (option.tax_name == "Late Fee") {
          // taxJson.key = option.tax_name;
          // taxJson.value = option.tax_amount;
          // taxJson.total = 0;
          // option.calculatedTax = 0;
          // taxList[index] = option;
        } else {
          monthlyTaxTotal = monthlyTaxTotal + (total * option.tax_amount) / 100;
          // taxList[index] = option;
          taxJson.key = option.tax_name;
          taxJson.value = option.tax_amount;
          taxJson.total = (total * option.tax_amount) / 100;
          //  setMiscellaneousTaxTotal(miscellaneousTaxTotal);
          taxJsonList.push(taxJson);
        }
      });
      SetTaxJsonList(taxJsonList);

      total = total + monthlyTaxTotal;
      setMaintenenceTotal(total);

      setTaxTotal(monthlyTaxTotal);
      setSubTotal(total);
      setTotalPayable(total - advanceReceived);

      document.getElementById("inputMaintenence").value = "";
      document.getElementById("inputAmount").value = "";
    } else if (maintenenceJsonList.length == 0) {
      let tempJson;
      let total = 0;
      for (var i = 0; i < maintenenceList.length; i++) {
        tempJson = { key: "", value: "" };
        tempJson.key = maintenenceList[i].maintenence_type;
        tempJson.value = maintenenceList[i].amount;
        total = total + maintenenceList[i].amount;
        // appliedTaxJsonList.push(appliedTaxJson);
        maintenenceJsonList.push(tempJson);
      }
      // for (var i = 0; i < taxList.length; i++) {
      //   tempJson = { key: "", value: "" ,total:""};
      //   if (taxList[i].tax_name === "Late Fee") {
      //     tempJson.key = taxList[i].tax_name;
      //     tempJson.value =taxList[i].tax_amount ;
      //     tempJson.total=lateFee;
      //     // appliedTaxJsonList.push(appliedTaxJson);
      //     maintenenceJsonList.push(tempJson);
      //   } else {
      //     tempJson.key = taxList[i].tax_name;
      //     tempJson.value = taxList[i].tax_amount;
      //     tempJson.total = (total * taxList[i].tax_amount) / 100;
      //     maintenenceJsonList.push(tempJson);
      //   }
      // }
    }
  }

  async function handleCHangeMaintenence(index) {
    if (selectedApartment) {
      if (
        document.getElementById("inputMaintenence").value &&
        document.getElementById("inputAmount").value
      ) {
        setCount1(index);
        alert("In HandleChange");

        mainteneceJson = { key: "", value: "" };
        mainteneceJson.key = document.getElementById("inputMaintenence").value;
        mainteneceJson.value = document.getElementById("inputAmount").value;

        if (isEditMonthlyInvoice) maintenenceJsonList.push(mainteneceJson);
        else otherJsonList.push(mainteneceJson);
        var total =
          maintenenceTotal +
          parseInt(document.getElementById("inputAmount").value);

        setMaintenenceTotal(total);

        alert("Total " + total);

        let monthlyTaxTotal = 0;

        console.log(taxJsonList);
        while (taxJsonList.length > 0) {
          taxJsonList.pop();
        }
        console.log(taxJsonList);

        taxList.map((option, index) => {
          console.log("Tax Name ", JSON.stringify(option), "Index " + index);
          taxJson = { key: "", value: "", total: "" };

          if (option.tax_name == "Late Fee") {
            // taxJson.key = option.tax_name;
            // taxJson.value = option.tax_amount;
            // taxJson.total = 0;
            // option.calculatedTax = 0;
            // taxList[index] = option;
          } else {
            monthlyTaxTotal =
              monthlyTaxTotal + (total * option.tax_amount) / 100;
            // taxList[index] = option;
            taxJson.key = option.tax_name;
            taxJson.value = option.tax_amount;
            taxJson.total = (total * option.tax_amount) / 100;
            //  setMiscellaneousTaxTotal(miscellaneousTaxTotal);
            taxJsonList.push(taxJson);
          }
        });
        SetTaxJsonList(taxJsonList);

        setTaxTotal(monthlyTaxTotal);
        setSubTotal(total + monthlyTaxTotal);
        setTotalPayable(total + monthlyTaxTotal - advanceReceived);

        document.getElementById("inputMaintenence").value = "";
        document.getElementById("inputAmount").value = "";
      } else {
        swal("First Fill Data !", "more error details", "warning");
      }
    } else {
      swal("First select owner !", "more error details", "warning");
    }
  }

  let miscellaneousJson;
  // const [miscellaneousJson,setMiscellaneousJson ]=React.useState( { name: "", amount: "", duration: "", total: "" });
  const [miscellaneousTaxTotal, setMiscellaneousTaxTotal] = React.useState(0);

  async function handleChangeDuration() {
    let amount = document.getElementById("misch_amt").value;
    let duration = document.getElementById("misch_duration").value;
    document.getElementById("misch_total").value =
      parseInt(amount) * parseInt(duration);

    let total = maintenenceTotal + parseInt(amount) * parseInt(duration);

    console.log("Total " + total);
    setMaintenenceTotal(total);

    let miscellaneousTaxTotal = 0;

    console.log(taxJsonList);

    while (taxJsonList.length > 0) {
      taxJsonList.pop();
    }
    console.log(taxJsonList);

    taxList.map((option, index) => {
      taxJson = { key: "", value: "", total: "" };

      if (option.tax_name == "Late Fee") {
        // taxJson.key = option.tax_name;
        // taxJson.value = option.tax_amount;
        // taxJson.total = 0;
      } else {
        // option.calculatedTax = (misc_total * option.tax_amount) / 100;
        miscellaneousTaxTotal =
          miscellaneousTaxTotal + (total * option.tax_amount) / 100;
        // taxList[index] = option;
        //  setMiscellaneousTaxTotal(miscellaneousTaxTotal);

        taxJson.key = option.tax_name;
        taxJson.value = option.tax_amount;
        taxJson.total = (total * option.tax_amount) / 100;
        taxJsonList.push(taxJson);
      }
    });

    SetTaxJsonList(taxJsonList);

    setTaxTotal(miscellaneousTaxTotal);
    setSubTotal(total + miscellaneousTaxTotal);
    setTotalPayable(total + miscellaneousTaxTotal - advanceReceived);
  }

  // Function to get last added miscllenious input fields without clicking plus icon
  async function handleChangeSave(index) {
    if (selectedApartment) {
      if (
        document.getElementById("misch_name").value &&
        document.getElementById("misch_amt").value &&
        document.getElementById("misch_duration").value
      ) {
        setCount2(index);
        alert("In HandleChange");

        miscellaneousJson = { name: "", amount: "", duration: "", total: "" };
        miscellaneousJson.name = document.getElementById("misch_name").value;
        miscellaneousJson.amount = document.getElementById("misch_amt").value;
        miscellaneousJson.duration =
          document.getElementById("misch_duration").value;
        let total =
          parseInt(document.getElementById("misch_amt").value) *
          parseInt(document.getElementById("misch_duration").value);
        document.getElementById("misch_total").value = total;
        miscellaneousJson.total = total;

        misch_JsonList.push(miscellaneousJson);

        // alert("Length " + misch_JsonList.length);
        // var misc_total = subTotal + total;
        // setSubTotal(misc_total);

        // taxList.map((option, index) => {
        //   if (option.tax_name == "Late Fee") {
        //     option.calculatedTax = 0;
        //     taxList[index] = option;
        //   } else {
        //     option.calculatedTax =
        //       ((subTotal + total) * option.tax_amount) / 100;
        //     setMiscellaneousTaxTotal(
        //       miscellaneousTaxTotal +
        //         ((subTotal + total) * option.tax_amount) / 100
        //     );
        //     taxList[index] = option;
        //     //  setMiscellaneousTaxTotal(miscellaneousTaxTotal);
        // }
        // });

        // setTotalPayable(
        //   subTotal + total - advanceReceived + miscellaneousTaxTotal
        // );

        document.getElementById("misch_name").value = "";
        document.getElementById("misch_amt").value = "";
        document.getElementById("misch_duration").value = "";
        document.getElementById("misch_total").value = 0;
      } else {
        if (misch_JsonList.length < 1)
          swal("Please Fill Data !", "more error details", "warning");
      }
    } else {
      swal("First select owner !", "more error details", "warning");
    }
  }

  //Executes when click on PLus icon in miscellaneous
  async function handleChangeMiscellaneous(index) {
    if (selectedApartment) {
      if (
        document.getElementById("misch_name").value &&
        document.getElementById("misch_amt").value &&
        document.getElementById("misch_duration").value
      ) {
        setCount2(index);
        alert("In HandleChange");

        miscellaneousJson = { name: "", amount: "", duration: "", total: "" };
        miscellaneousJson.name = document.getElementById("misch_name").value;
        miscellaneousJson.amount = document.getElementById("misch_amt").value;
        miscellaneousJson.duration =
          document.getElementById("misch_duration").value;

        miscellaneousJson.total = document.getElementById("misch_total").value;

        // let total=miscellaneousJson.total;

        misch_JsonList.push(miscellaneousJson);

        alert("Length " + misch_JsonList.length);

        document.getElementById("misch_name").value = "";
        document.getElementById("misch_amt").value = "";
        document.getElementById("misch_duration").value = "";
        document.getElementById("misch_total").value = 0;
      } else {
        swal("First Fill Data !", "more error details", "warning");
      }
    } else {
      swal("First select owner !", "more error details", "warning");
    }
  }

  async function handleClickMinus(index) {
    setMischJsonList(misch_JsonList.splice(index, 1));
  }

  const [count3, setCount3] = useState(0);

  async function handleChangeAmenityJson(index) {
    if (selectedApartment) {
      if (
        document.getElementById("selectedAmenity").value &&
        document.getElementById("amenity_duration").value
      ) {
        setCount3(index);
        alert("In HandleChange");

        miscellaneousJson = { name: "", amount: "", duration: "", total: "" };
        miscellaneousJson.name = selectedAmenityName;
        miscellaneousJson.amount = amount;
        miscellaneousJson.duration =
          document.getElementById("amenity_duration").value;
        miscellaneousJson.total =
          document.getElementById("AmenityTotalAmt").value;

        misch_JsonList.push(miscellaneousJson);

        amenitiesJsonList.push(miscellaneousJson);

        // var misc_total = subTotal + total;

        // var  miscellaneousTaxTotal=0;

        // taxList.map((option, index) => {
        //   if (option.tax_name == "Late Fee") {
        //     option.calculatedTax = 0;
        //     taxList[index] = option;
        //   } else {
        //     option.calculatedTax = (misc_total * option.tax_amount) / 100;
        //     miscellaneousTaxTotal=  miscellaneousTaxTotal + (misc_total * option.tax_amount) / 100;
        //     taxList[index] = option;
        //     //  setMiscellaneousTaxTotal(miscellaneousTaxTotal);
        //   }
        // });

        // misc_total=misc_total+miscellaneousTaxTotal;
        // setSubTotal(misc_total);
        // setTotalPayable(misc_total - advanceReceived);

        document.getElementById("selectedAmenity").value = "";
        document.getElementById("amenityAmt").value = 0;
        document.getElementById("amenity_duration").value = 0;
        document.getElementById("AmenityTotalAmt").value = 0;
      } else {
        swal("First Fill Data !", "more error details", "warning");
      }
    } else {
      swal("First select owner !", "more error details", "warning");
    }
  }

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Send Invoice</h1>
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div className="createInvoiceNewMain">
              <div className="invoicePaidUnpaidTabMain">
                <div className="createNewTemplateMain">
                  <Formik
                    enableReinitialize
                    initialValues={formikInitials}
                    validationSchema={Validation_Schema}
                    onSubmit={saveInvoice}
                  >
                    {({
                      values,
                      handleChange,
                      errors,
                      setFieldTouched,
                      touched,
                      isValid,
                      handleSubmit,
                    }) => (
                      <Form>
                        <div className="invoiceMain">
                          <div className="invoiceInnerMain">
                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <h2 className="invoiceSubHeading">
                                  Create Invoice
                                </h2>
                              </Grid>
                            </Grid>

                            <Grid container spacing={3}>
                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">
                                  Invoice Name
                                </label>
                                <input
                                  className="inputSt"
                                  placeholder="267345"
                                  value={invoiceNo}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">
                                  Invoice Date
                                </label>
                                <div className="dateTimeMain">
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack className="inputSt">
                                      <DesktopDatePicker
                                        inputFormat="MM/DD/YYYY"
                                        value={invoice_date}
                                        onChange={handleInvoiceDate}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>
                                </div>
                                {/* <input type="date" className="inputSt" value={values.invoice_date} onChange={handleInvoiceDate} /> */}
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">Due Date</label>
                                <div className="dateTimeMain">
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack className="inputSt">
                                      <DesktopDatePicker
                                        inputFormat="MM/DD/YYYY"
                                        value={due_date}
                                        onChange={handleDueDate}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>
                                </div>
                                {/* <input type="date" className="inputSt" value={values.due_date} onChange={handleDueDate} /> */}
                              </Grid>
                            </Grid>

                            <div className="addAminitiesMainNew">
                              <Grid container spacing={3}>
                                <Grid item xs={12} md={12}>
                                  <div className="showingAminitiesNew">
                                    <Grid container>
                                      <Grid item xs={12} md={12}>
                                        <h2 className="invoiceSubHeading">
                                          Invoice Details
                                        </h2>
                                      </Grid>
                                    </Grid>

                                    {misch_JsonList.map((option, index) => (
                                      <div
                                        className="addedAppendLine"
                                        id="deleteId"
                                      >
                                        <Grid container spacing={3}>
                                          <Grid item xs={12} md={3}>
                                            <input
                                              className="inputSt"
                                              placeholder="Maintenence Name"
                                              value={option.name}
                                            />
                                          </Grid>
                                          <Grid item xs={12} md={3}>
                                            <div className="inputWithICon">
                                              <CurrencyRupeeIcon />
                                              <input
                                                className="inputSt"
                                                placeholder="Amount"
                                                value={option.amount}
                                              />
                                            </div>
                                          </Grid>
                                          <Grid item xs={12} md={3}>
                                            <div className="inputWithICon">
                                              <input
                                                className="inputSt durationField"
                                                placeholder="Duration"
                                                value={option.duration}
                                              />
                                            </div>
                                          </Grid>
                                          <Grid item xs={12} md={3}>
                                            <div className="inputWithICon">
                                              <CurrencyRupeeIcon />
                                              <input
                                                className="inputSt"
                                                placeholder="Total"
                                                value={option.total}
                                              />
                                            </div>
                                          </Grid>

                                          <Button className="minusBtnNew">
                                            <RemoveIcon
                                              onClick={() =>
                                                handleClickMinus(index)
                                              }
                                            />
                                          </Button>
                                        </Grid>
                                      </div>
                                    ))}

                                    <div className="appendLine">
                                      <Grid container spacing={3}>
                                        <Grid item xs={12} md={3}>
                                          <input
                                            className="inputSt miscName"
                                            placeholder="Maintenence Name"
                                            id="misch_name"
                                          />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                          <div className="inputWithICon">
                                            <CurrencyRupeeIcon />
                                            <input
                                              className="inputSt"
                                              placeholder="Amount"
                                              id="misch_amt"
                                            />
                                          </div>
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                          <div className="inputWithICon">
                                            <input
                                              className="inputSt durationField"
                                              placeholder="Duration"
                                              id="misch_duration"
                                              onBlur={() =>
                                                handleChangeDuration()
                                              }
                                            />
                                          </div>
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                          <div className="inputWithICon">
                                            <CurrencyRupeeIcon />
                                            <input
                                              className="inputSt"
                                              placeholder="Total"
                                              id="misch_total"
                                            />
                                          </div>
                                        </Grid>
                                      </Grid>
                                      <Button
                                        className="plusBtn"
                                        onClick={() =>
                                          handleChangeMiscellaneous(count1 + 1)
                                        }
                                      >
                                        <AddIcon />
                                      </Button>
                                    </div>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>

                            {/* <Grid style={{ marginTop: 25 }}> */}
                            {/*For Append */}
                            {/* {[...Array(count)].map((_, i) => (
                                    <AddedElement key={i} />
                                  ))} */}
                            {/* End */}
                            {/* </Grid> */}

                            <div className="otherFieldsAdd" id="addAminitiesId">
                              {/* <Grid container spacing={3}>
                          <Grid item xs={12} md={12}>
                            <Button
                              className="addAminitiesBt"
                              onClick={addAminitiesClick}
                            >
                              <AddIcon />
                            </Button>
                          </Grid>
                        </Grid> */}

                              <div className="extraFieldsAdd">
                                <Grid
                                  container
                                  spacing={3}
                                  className="botSpfild botSpfild2"
                                >
                                  <Grid item xs={12} md={12}>
                                    <select
                                      className="inputSt"
                                      value={selectedAmenity}
                                      onChange={handlechangeAmenity}
                                      onBlur={() =>
                                        setFieldTouched("selectedAmenity")
                                      }
                                      id="selectedAmenity"
                                      // onChangeCapture={(e) => setSelectedOwner(e.target.value)}
                                    >
                                      <option>Select Amenity</option>
                                      {amenitiesList.map((option) => (
                                        <option
                                          key={option.amenity_id}
                                          value={option.amenity_id}
                                          data-isd={option.charges}
                                          data-name={option.amenity_name}
                                        >
                                          {option.amenity_name}
                                        </option>
                                      ))}
                                    </select>
                                  </Grid>

                                  <Grid item xs={12} md={4}>
                                    <div className="inputWithICon">
                                      <CurrencyRupeeIcon />
                                      <input
                                        className="inputSt"
                                        placeholder="Amount"
                                        value={amount}
                                        id="amenityAmt"
                                        disabled
                                      />
                                    </div>
                                  </Grid>

                                  <Grid item xs={12} md={4}>
                                    <div className="inputWithICon">
                                      <input
                                        className="inputSt"
                                        placeholder="No Of Days"
                                        value={values.noOfDays}
                                        onChange={handleInputDays}
                                        onBlur={() => setNoOfDays("noOfDays")}
                                        id="amenity_duration"
                                      />
                                    </div>
                                  </Grid>

                                  <Grid item xs={12} md={4}>
                                    <div className="inputWithICon">
                                      <CurrencyRupeeIcon />
                                      <input
                                        className="inputSt"
                                        placeholder=""
                                        disabled
                                        id="AmenityTotalAmt"
                                      />
                                    </div>
                                  </Grid>

                                  <Grid item xs={12} md={12}>
                                    <Button
                                      className="plsBtIco"
                                      onClick={() =>
                                        handleChangeAmenityJson(count3 + 1)
                                      }
                                    >
                                      <AddIcon />
                                    </Button>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                            <div className="totalCalculation">
                              <div className="totalLab">Total</div>
                              <div className="totalamt">
                                <CurrencyRupeeIcon /> {maintenenceTotal}
                              </div>
                            </div>
                            <div className="clear"></div>
                            <div
                              className="addAminitiesMain noPad"
                              id="addAminitiesId"
                            >
                              <Grid container>
                                {/* <Grid item xs={12} md={12}>
                                <Button className="addAminitiesBt">
                                  <AddIcon /> Add Other Maintenance
                                </Button>
                              </Grid> */}
                                <Grid item xs={12} md={12}>
                                  <div className="showingAminities">
                                    <Grid container>
                                      <Grid item xs={12} md={12}>
                                        <h2 className="invoiceSubHeading">
                                          Other Maintenence Details
                                        </h2>
                                      </Grid>
                                    </Grid>

                                    {/*For Append */}
                                    {/* {[...Array(count)].map((_, i) => (
                                    <AddedElement key={i} />
                                  ))} */}
                                    {/* End */}

                                    <div className="appendLine">
                                      <Grid container spacing={3}>
                                        <Grid item xs={12} md={8}>
                                          <input
                                            className="inputSt"
                                            placeholder="Maintenence Name"
                                          />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                          <div className="inputWithICon">
                                            <CurrencyRupeeIcon />
                                            <input
                                              className="inputSt"
                                              placeholder="Amount"
                                            />
                                          </div>
                                        </Grid>
                                      </Grid>
                                      <Button
                                        className="plusBtn"
                                        // onClick={() => setCount2(count + 1)}
                                      >
                                        {" "}
                                        Other
                                        <AddIcon />
                                      </Button>
                                    </div>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                            {taxJsonList.map((option) => (
                              <Grid
                                container
                                spacing={3}
                                className="taxfiled botSpfild"
                              >
                                <Grid item xs={12} md={6}>
                                  <input
                                    className="inputSt"
                                    value={option.key}
                                  />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                  <div className="inputWithICon">
                                    <PercentSharpIcon />
                                    <input
                                      className="inputSt"
                                      value={option.value}
                                    />
                                  </div>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                  <div className="inputWithICon">
                                    <CurrencyRupeeIcon />
                                    <input
                                      className="inputSt"
                                      value={parseFloat(option.total).toFixed(
                                        2
                                      )}
                                    />
                                  </div>
                                </Grid>
                              </Grid>
                            ))}
                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <h2 className="invoiceSubHeading">
                                  Calculate Invoice
                                </h2>
                              </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                              <Grid item xs={12} md={12}>
                                <input
                                  className="inputSt"
                                  placeholder="Notes"
                                  value={values.note}
                                  onChange={handleChange("note")}
                                  onBlur={() => setFieldTouched("note")}
                                  onChangeCapture={(e) =>
                                    setNote(e.target.value)
                                  }
                                />
                                {errors.note && touched.note ? (
                                  <div
                                    style={{ color: "red" }}
                                    className="errorField"
                                  >
                                    {errors.note}
                                  </div>
                                ) : null}
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">Sub total</label>
                                <div className="inputWithICon greenTextFildSVG">
                                  <CurrencyRupeeIcon />
                                  <input
                                    className="inputSt greenTextFild"
                                    placeholder="7000"
                                    disabled
                                    value={parseFloat(subTotal).toFixed(2)}
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">
                                  Advance Recived
                                </label>
                                <div className="inputWithICon greenTextFildSVG">
                                  <CurrencyRupeeIcon />
                                  <input
                                    className="inputSt greenTextFild"
                                    placeholder="3000"
                                    value={parseFloat(advanceReceived).toFixed(
                                      2
                                    )}
                                    onChange={handleChange("advanceReceived")}
                                    onBlur={() =>
                                      setFieldTouched("advanceReceived")
                                    }
                                    onChangeCapture={(e) =>
                                      handleAdvanceReceived(e.target.value)
                                    }
                                  />
                                  {errors.advanceReceived &&
                                  touched.advanceReceived ? (
                                    <div
                                      style={{ color: "red" }}
                                      className="errorField"
                                    >
                                      {errors.advanceReceived}
                                    </div>
                                  ) : null}
                                </div>
                              </Grid>

                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">
                                  Total Payable
                                </label>
                                <div className="inputWithICon greenTextFildSVG">
                                  <CurrencyRupeeIcon />
                                  <input
                                    className="inputSt greenTextFild"
                                    placeholder="4000"
                                    value={parseFloat(totalPayable).toFixed(2)}
                                  />
                                </div>
                              </Grid>
                            </Grid>

                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <h2 className="invoiceSubHeading">Send To</h2>
                              </Grid>
                            </Grid>

                            <div className="sendToOuter">
                              <Grid container spacing={3}>
                                <Grid item xs={12} md={12}>
                                  <div className="radioGroupNew">
                                    <FormControl>
                                      <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        defaultValue="female"
                                        name="radio-buttons-group"
                                      >
                                        <FormControlLabel
                                          value="All"
                                          control={<Radio />}
                                          label="All"
                                        />
                                        <FormControlLabel
                                          value="Committee Members"
                                          control={<Radio />}
                                          label="Committee Members"
                                        />
                                        <FormControlLabel
                                          value="All Owners"
                                          control={<Radio />}
                                          label="All Owners"
                                        />
                                        <FormControlLabel
                                          value="Individual"
                                          control={<Radio />}
                                          label="Individual"
                                        />
                                      </RadioGroup>
                                    </FormControl>
                                  </div>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                  <div className="searchOut">
                                    <div className="modalInput">
                                      <SearchIcon />
                                      <input
                                        className="modalInputSt"
                                        placeholder="Search Members"
                                      />
                                    </div>
                                  </div>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                  <div className="visitContDivScroll">
                                    <div className="visitContDiv visitContDivNotice">
                                      <div className="visitCont1 resideNewContOut">
                                        <div className="visitContProf">
                                          <Zoom>
                                            <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" />
                                          </Zoom>
                                        </div>
                                        <div className="visitContLeft">
                                          <h3 className="visitContHed">
                                            Robert Wilson
                                          </h3>
                                          <p className="visitContMob">
                                            5236412563
                                          </p>
                                        </div>

                                        <div className="visitBottCont">
                                          <p>Shiv Shakti/Wing B/F-602</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="visitContDiv visitContDivNotice activeTicketList">
                                      <div className="visitCont1 resideNewContOut">
                                        <div className="visitContProf">
                                          <Zoom>
                                            <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" />
                                          </Zoom>
                                        </div>
                                        <div className="visitContLeft">
                                          <h3 className="visitContHed">
                                            Robert Wilson
                                          </h3>
                                          <p className="visitContMob">
                                            5236412563
                                          </p>
                                        </div>

                                        <div className="visitBottCont">
                                          <p>Shiv Shakti/Wing B/F-602</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="visitContDiv visitContDivNotice">
                                      <div className="visitCont1 resideNewContOut">
                                        <div className="visitContProf">
                                          <Zoom>
                                            <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" />
                                          </Zoom>
                                        </div>
                                        <div className="visitContLeft">
                                          <h3 className="visitContHed">
                                            Robert Wilson
                                          </h3>
                                          <p className="visitContMob">
                                            5236412563
                                          </p>
                                        </div>

                                        <div className="visitBottCont">
                                          <p>Shiv Shakti/Wing B/F-602</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="visitContDiv visitContDivNotice">
                                      <div className="visitCont1 resideNewContOut">
                                        <div className="visitContProf">
                                          <Zoom>
                                            <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" />
                                          </Zoom>
                                        </div>
                                        <div className="visitContLeft">
                                          <h3 className="visitContHed">
                                            Robert Wilson
                                          </h3>
                                          <p className="visitContMob">
                                            5236412563
                                          </p>
                                        </div>

                                        <div className="visitBottCont">
                                          <p>Shiv Shakti/Wing B/F-602</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="visitContDiv visitContDivNotice">
                                      <div className="visitCont1 resideNewContOut">
                                        <div className="visitContProf">
                                          <Zoom>
                                            <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" />
                                          </Zoom>
                                        </div>
                                        <div className="visitContLeft">
                                          <h3 className="visitContHed">
                                            Robert Wilson
                                          </h3>
                                          <p className="visitContMob">
                                            5236412563
                                          </p>
                                        </div>

                                        <div className="visitBottCont">
                                          <p>Shiv Shakti/Wing B/F-602</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="visitContDiv visitContDivNotice">
                                      <div className="visitCont1 resideNewContOut">
                                        <div className="visitContProf">
                                          <Zoom>
                                            <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" />
                                          </Zoom>
                                        </div>
                                        <div className="visitContLeft">
                                          <h3 className="visitContHed">
                                            Robert Wilson
                                          </h3>
                                          <p className="visitContMob">
                                            5236412563
                                          </p>
                                        </div>

                                        <div className="visitBottCont">
                                          <p>Shiv Shakti/Wing B/F-602</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  md={12}
                                  className="previewBtOuter"
                                >
                                  <Button
                                    className="addBt PreviewBtn"
                                    onClick={() => saveInvoice()}
                                  >
                                    Send Invoice
                                  </Button>
                                  {/* <Button
                                      className="addBt PreviewBtn"
                                      onClick={() => navigate("/InvoicePreview")}
                                    >
                                      Preview
                                    </Button> */}
                                </Grid>
                              </Grid>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default SendInvoiceTo;
